import React from "react";
import Careeratdasmesh from "../components/Contact/career-das"; 
import Banner from '../comman/Banner/Banner';


const Careerdasmesh = () => {
  return (
    <>
    <Banner 
     index={'react-career'}
    />
    <Careeratdasmesh/>    
    </>

  )
};

export default Careerdasmesh;